import React from "react";
import EmailForm from "../../components/EmailForm";
import ResetPasswordForm from "../../components/ResetPasswordForm";
import { faPaperPlane } from "@fortawesome/fontawesome-free-solid";
import { Alert } from "reactstrap";
import {
  compose,
  withHandlers,
  setDisplayName,
  withProps,
  branch,
  renderComponent
} from "recompose";
import { connect } from "react-redux";
import { actions } from "../../modules/auth";
import { Link, withRouter } from "react-router-dom";
import { parse } from "qs";

const mapStateToProps = state => ({
  ...(state.auth || {})
});

const mapActionCreators = {
  forgotPassword: actions.forgotPassword,
  resetPassword: actions.resetPassword,
  resetState: actions.resetState
};

const ForgotPasswordForm = compose(
  setDisplayName("ForgotPasswordForm"),
  connect(
    mapStateToProps,
    mapActionCreators
  ),
  withRouter,
  withProps(({ location: { search } }) => ({
    reset_token: parse(search, { ignoreQueryPrefix: true }).reset_token
  })),
  withHandlers({
    handleForgotPassword: ({ forgotPassword }) => data => {
      forgotPassword(data);
    },
    handleResetPassword: ({
      resetPassword,
      reset_token,
      history: { push }
    }) => async data => {
      const { response } = await resetPassword(
        Object.assign({}, data, { token: reset_token })
      );
      if (response) {
        push("/contracts");
      }
    }
  }),
  branch(
    ({ reset_token }) => !!reset_token,
    renderComponent(
      withProps(({ authenticating, failAuth, handleResetPassword }) => ({
        authenticating,
        failAuth,
        onSubmit: handleResetPassword
      }))(ResetPasswordForm)
    )
  )
)(({ successForgot, authenticating, failAuth, handleForgotPassword }) => (
  <div>
    {successForgot && <Alert color="success">{successForgot}</Alert>}
    <EmailForm
      submitting={authenticating}
      failSubmit={failAuth}
      onSubmit={handleForgotPassword}
      initialValues={{ email: "" }}
      action="Send"
      icon={faPaperPlane}
    />
  </div>
));

const ForgotPassword = props => (
  <div>
    <ForgotPasswordForm {...props} />
    {/* <div style={{ marginTop: 10, marginBottom: 10, textAlign: "center" }}>
      <Link to="/signup" style={{ color: "#00c7a5" }}>
        I don't have an account.
      </Link>
    </div> */}
    <div style={{ marginTop: 10, marginBottom: 10, textAlign: "center" }}>
      <Link to="/" style={{ color: "#00c7a5" }}>
        I have an account
      </Link>
    </div>
  </div>
);

export default ForgotPassword;
